import 'plyr-react/dist/plyr.css';

import React from 'react';

import Plyr from 'plyr-react';

import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Container } from '../../modules/Container';
import { media } from '../../services/media';
import { parseHTML } from '../../services/parseHTML';
import { Storyblok, StoryblokSection } from '../../storyblok';

export function YoutubeVideo({
    sectionData,
    ...restProps
}: StoryblokSection<Storyblok.Component.YoutubeVideo>) {
    const { videoUrl, disablePadding, content, heading } = sectionData;

    const Player = videoUrl ? (
        <Plyr
            source={{
                type: 'video',
                sources: [
                    {
                        src: videoUrl,
                        provider: 'youtube',
                    },
                ],
            }}
            options={{
                settings: ['quality'],
                quality: {
                    default: 1080,
                    options: [
                        4320, 2880, 2160, 1440, 1080, 720, 576, 480, 360, 240,
                    ],
                },
                /* https://github.com/sampotts/plyr#options */
            }}
            {
                ...{
                    /* Direct props for inner video tag (mdn.io/video) */
                }
            }
        />
    ) : null;

    const ContentAndHeading = (
        <Container size="960px" noPadding={false}>
            <Heading>{heading}</Heading>
            <ContentWrapper>
                {Player}
                {content && <Content>{parseHTML(content, 'markdown')}</Content>}
            </ContentWrapper>
        </Container>
    );

    return (
        <Section
            disablePadding={disablePadding}
            withContent={content ? true : false}
            {...restProps}
        >
            {content && heading ? ContentAndHeading : Player}
        </Section>
    );
}

const Heading = styled.h2``;

const ContentWrapper = styled.div`
    display: grid;
    grid-template-columns: 1fr;
    gap: 20px;
    align-items: center;
    justify-content: center;

    ${media.min('md')} {
        grid-template-columns: 59fr 45fr;
    }
`;

const Section = styled.section<{
    disablePadding: boolean;
    withContent: boolean;
}>`
    ${(props) =>
        props.disablePadding &&
        css`
            padding: 0 !important;
        `}

    ${(props) =>
        props.withContent &&
        css`
            background-color: rgb(183, 205, 222);
            padding: 60px 0;
        `}
`;

const Content = styled.div`
    font-size: 20px;
    p {
        line-height: 1.47;

        :last-of-type {
            margin: 0;
        }
    }
`;
